// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

import Modules from "../assets/icons/play-list_w.svg";

const icons = {
  modules: () => <img src={Modules} alt="modules icon" />,
};
// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const modules = {
  id: "modules",
  title: <FormattedMessage id="modules" />,
  type: "group",
  url: "/modules",
  icon: icons.modules,
  disabled: false,
};

export default modules;
